import { forwardRef, type Ref, type SVGProps } from "react";
const IconPhoneCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m-4.32 21.07h-.12l-.15-.07-.1-.05a.44.44 0 0 1-.14-.13l-.07-.06a1 1 0 0 1-.13-.26l-.92-2.7a.87.87 0 0 1 .41-1.05l2.92-1.55a.9.9 0 0 1 .36-.09h.4a1 1 0 0 1 .26.17l1.43 1.25a5.11 5.11 0 0 0 2.51-3.8l-1.64-1a.89.89 0 0 1-.36-1l1-3.1a.64.64 0 0 1 .15-.25.2.2 0 0 1 .07-.07l.14-.13h.11a.8.8 0 0 1 .19-.11h.34l2.87.4a.76.76 0 0 1 .71.75c.67 7-3.07 12.2-10 12.9a.7.7 0 0 1-.24-.05"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPhoneCircleFilledSVG);
ForwardRef.displayName = "IconPhoneCircleFilled";
export { ForwardRef as IconPhoneCircleFilled };
